import { render, staticRenderFns } from "./Pbg.vue?vue&type=template&id=d11837d8&scoped=true&"
import script from "./Pbg.vue?vue&type=script&lang=js&"
export * from "./Pbg.vue?vue&type=script&lang=js&"
import style0 from "./Pbg.vue?vue&type=style&index=0&id=d11837d8&scoped=true&lang=css&"
import style1 from "./Pbg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11837d8",
  null
  
)

export default component.exports